import { render, staticRenderFns } from "./SupplierManualDirList.vue?vue&type=template&id=454ae534&scoped=true&lang=pug&"
import script from "./SupplierManualDirList.vue?vue&type=script&lang=js&"
export * from "./SupplierManualDirList.vue?vue&type=script&lang=js&"
import style0 from "./SupplierManualDirList.vue?vue&type=style&index=0&id=454ae534&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454ae534",
  null
  
)

export default component.exports